// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/remote-config';
import { ɵzoneWrap } from '@angular/fire';
import {
  activate as _activate,
  ensureInitialized as _ensureInitialized,
  fetchAndActivate as _fetchAndActivate,
  fetchConfig as _fetchConfig,
  getAll as _getAll,
  getBoolean as _getBoolean,
  getNumber as _getNumber,
  getRemoteConfig as _getRemoteConfig,
  getString as _getString,
  getValue as _getValue,
  setLogLevel as _setLogLevel
} from 'firebase/remote-config';

export {
  isSupported
} from './overrides';

export const activate = ɵzoneWrap(_activate, true);
export const ensureInitialized = ɵzoneWrap(_ensureInitialized, true);
export const fetchAndActivate = ɵzoneWrap(_fetchAndActivate, true);
export const fetchConfig = ɵzoneWrap(_fetchConfig, true);
export const getAll = ɵzoneWrap(_getAll, true);
export const getBoolean = ɵzoneWrap(_getBoolean, true);
export const getNumber = ɵzoneWrap(_getNumber, true);
export const getRemoteConfig = ɵzoneWrap(_getRemoteConfig, true);
export const getString = ɵzoneWrap(_getString, true);
export const getValue = ɵzoneWrap(_getValue, true);
export const setLogLevel = ɵzoneWrap(_setLogLevel, true);
